import enGB from './en-GB.json'
import jaJP from './ja-JP.json'

export const allLocales = {
  'en-GB': enGB,
  'ja-JP': jaJP,
}
